// Marketing conversion tracking.
// Fires to the Meta pixel and pushes to dataLayer so GTM / Google Ads see the
// same events. These are ACQUISITION events: only fire them for logged-out or
// first-time customers, never for repeat bookings from signed-in accounts.
// Tracking must never break a form, so every call is wrapped.
//
// dataLayer events are deliberately namespaced (ma_lead / ma_purchase). The
// GTM container has a Meta Conversions API tag whose lookup table maps the
// generic names generate_lead -> Lead and purchase -> Purchase, so using those
// names would make GTM fire a SECOND Meta event on top of the fbq call below.
// Build Google Ads conversion tags off ma_lead / ma_purchase.

// Funnel diagnostic only: never a lead/purchase conversion, and no personal data.
export const trackBookingStart = (source, placement) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'ma_booking_start', booking_source: source, booking_placement: placement });
  } catch (e) {
    // Tracking must never prevent booking.
  }
};

export const trackLead = (source, params = {}) => {
  try {
    if (window.fbq) {
      window.fbq('track', 'Lead', { content_name: source, ...params })
    }
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'ma_lead', lead_source: source, ...params })
    }
  } catch (e) {
    // no-op
  }
}

export const trackPurchase = (source, value, params = {}) => {
  try {
    const numericValue = Number(value)
    const payload = {
      content_name: source,
      currency: 'USD',
      ...(isFinite(numericValue) && numericValue > 0 ? { value: numericValue } : {}),
      ...params
    }
    if (window.fbq) {
      window.fbq('track', 'Purchase', payload)
    }
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'ma_purchase', purchase_source: source, ...payload })
    }
  } catch (e) {
    // no-op
  }
}
